import { render } from "./YearlyPricing.vue?vue&type=template&id=9c24ecb0"
import script from "./YearlyPricing.vue?vue&type=script&lang=js"
export * from "./YearlyPricing.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__